import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { BranchService } from 'src/app/services/branch.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router,
    private branchService: BranchService) { }

  canActivate(): Observable<boolean> {
    return new Observable<boolean>((subscriber) => {
      this.authService.currentUser.subscribe((user) => {
        if (user) {
          subscriber.next(true);
        } else {
          this.router.navigate(['/login']);
          subscriber.next(false);
        }
      });
    });
  }

}
